module.exports = __webpack_public_path__ + "static/eventPerson1-4052ffc1a9cf62a0be14d5dc96ec62b8.jpeg";